import { Component, OnInit, AfterViewInit, ViewEncapsulation, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { ManageInventoryService } from '../../manage-inventory/shared/providers/manage-inventory.service';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { SignupSetupInputModel, SignupSetupOutputModel, FanModel, EnrollmentDateModel } from '../../signup-setup/shared/models/signup-setup.models';
// import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { SIGNUPSETUPDATA } from 'config';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { MOBILEPIVOTS, TERMSCONDITIONS, ERRCODES } from 'config';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { SignupSetupService } from '../shared/providers/signup-setup.service';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { ProductSelectionService } from '../../product-selection/product-selection.service';



@Component({
  selector: 'app-enrollment-signup-setup',
  templateUrl: './enrollment-signup-setup.component.html',
  styleUrls: ['./enrollment-signup-setup.component.scss'],
  providers: [SignupSetupService, ManageInventoryService, AdobeAnalyticsService, ProductSelectionService],
  encapsulation: ViewEncapsulation.None
})

export class EnrollmentSignupSetupComponent implements OnInit, AfterViewInit {

  @ViewChild('fileInput') fileInput: ElementRef;
  gridOptions: Array<GridOptionsModel>;
  stepIndicators: StepIndicatorModel[];
  confirmModalPopup: ConfirmModalPopupModel;
  stepSessionName: string;
  initModal: boolean;
  modalMsg: string;
  mailId: string;
  videoId: string;
  modalClass: string;
  signupSetup: boolean = false;
  backFromReview: boolean = false;
  signupSetupInputData: SignupSetupInputModel;
  signupSetupOutputData: SignupSetupOutputModel;
  companyId: number;
  haveTab: boolean;
  activeTab: number;
  selectedFanList: number;
  tabArray: Array<any>;
  accordionList: boolean;
  pageTitle: string;
  pageDescription: string;
  pageLink: string;
  pageDescription2: string;
  accountsData: any;
  showError: boolean;
  errorMessage: string;
  showGoogleCreationError: boolean;
  dcmCodes = 'ABC_TNC_001';
  haveAccordion: boolean;
  eligibleFanCount: number;
  pivots: Array<MobilePivotModel>;
  termscondUrl: any;
  termsCondproductURl: any;
  selected: any;
  eventEmit: any;
  title: any;
  supportArticle: any;
  showOverviewModal: boolean;
  private enrollDates: EnrollmentDateModel;
  private FANListSel: Array<FanModel> = [];
  private FANListAdd: Array<FanModel> = [];
  private FANListAct: Array<FanModel> = [];
  private FANListPro: Array<FanModel> = [];
  private FANListALL: Array<FanModel> = [];
  private successfullySignupFAN: Array<FanModel> = [];
  selectedFansCount: Array<number> = [];
  helpArticles: any;
  article: any;
  isMobile: any;
  termsCondi: any;
  staticTcUrl: any;
  guideUrl: any;
  MdmSelection: any;
  prodFlag: boolean;
  emmProductCode: any;
  tmc: any;
  kme: boolean;
  ztp: boolean;
  abm: boolean;
  mdm: boolean;
  querytab: string;
  supportArticles: any;
  ztpIdres:any;
  prodcode: string;
  emailEnabled: boolean = true;
  smsEnabled: boolean = true;
  notificationType: any = '';
  @ViewChild('emailNotification') emailNotification: ElementRef;
  @ViewChild('textMessageNotification') textMessageNotification: ElementRef;
  @ViewChild('enrollBox') enrollBox: ElementRef;
  initialSignup: boolean = false;
  readySignupSetupFans: any[];
  isFansZero: boolean = false;
  enableCont: boolean = false;
  signupData: any;
  notfFlag: boolean = false;
  canEnroll: boolean = false;
  enrollArray: any[] = [];
  showErrors: boolean = false;
  enrollEnable: boolean = false;
  allFansData: any;
  signupDataBack: any;
  checkedFanList: any;
  failFromReviewFlag: string;
  isROMEFailed: boolean = false;
  isABMFE: boolean = false;
  existingDevicesTooltipForABMFE: string = '';
  existingDevicesTooltipCommon: string = '';//please change this tooltip when the mongodb changes happend for existingDevicesTooltip
  abmfeRequiredFields: any;
  IFDErrorMessage: string = '';
  IFDErrorCode: string = '';
  IFDCommonErrorMessage: string = ERRCODES['ABM_FE_COMMON_ERROR_MESSAGE'];
  IFDGenericErrorMessage: string = ERRCODES['ABM_FE_GENERIC_ERROR_MESSAGE'];
  IFDMock: boolean = false;
  psComponent: any;
  productSelected: any;
  isMobileView: boolean = window.innerWidth <= 768;
  profileAndPermsInfo: any;
  fans: any;
  fanNames: any;
  matchingFan: any;
  companyName: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.mobileView();
  }

  constructor(private router: Router,
    private pageloaderService: PageLoaderService,
    private activatedRoute: ActivatedRoute,
    private signupSetupService: SignupSetupService,
    private manageInventoryService: ManageInventoryService,
    private utilityService: UtilityService,
    private stepindicatorService: StepIndicatorService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private breadCrumbService: BreadCrumbService,
    private pageLoaderService: PageLoaderService,
    private productSelectionService: ProductSelectionService,
    private location: Location) {

    this.selected = { newSetupFanList: false, revisedFanList: false, awaitingSignupFanList: false };
    this.gridOptions = [];
    this.tabArray = [];
    this.activeTab = 0;
    this.haveTab = false;
    this.showGoogleCreationError = false;
    this.accountsData = {};
    this.accountsData.config = SIGNUPSETUPDATA.EnrollmentOptions;
    this.pageloaderService.setPageLoaderStatus(false);
    const profileData = JSON.parse(sessionStorage.getItem('user'));
    this.mailId = profileData.user.emailAddress;
    this.existingDevicesTooltipForABMFE = "Existing devices includes all the devices under your foundation account. If selected, all existing devices will be added to the AT&T Device Management Program within 1 business day after a successful enrollment.";
    this.existingDevicesTooltipCommon = "Existing devices includes all the devices purchased under your foundation account before your <prodID> was added to the account. If selected, all existing devices will be added to the AT&T Device Management Program within 1 business day after a successful enrollment.";
    this.abmfeRequiredFields = {
      "accountDetails": [
        { attrName: 'orgName', required: true, size: 128 },
        { attrName: 'orgCountry', required: true, size: 3 },
        { attrName: 'orgPhone', required: true, size: 128 },
        { attrName: 'orgAddress1', required: true, size: 128 },
        // {attrName: 'orgAddress2', required: false, size: 128},
        // {attrName: 'orgAddress3', required: false, size: 128},
        // {attrName: 'orgPostalCode', required: false, size: 32},
        // {attrName: 'orgRegion', required: false, size: 96},
        // {attrName: 'orgCity', required: false, size: 128}
      ],
      "customerContactDetails": [
        { attrName: 'firstName', required: true, size: 128 },
        { attrName: 'lastName', required: true, size: 128 },
        { attrName: 'email', required: true, size: 256 },
        { attrName: 'type', required: true, size: 128 }
      ]
    }

    const state = this.location.getState();
    console.log("data------", state);

    if(state.hasOwnProperty('ztpIdres')){
      this.ztpIdres = state['ztpIdres'];
    }else{
      this.ztpIdres = null;
    }
  }

  ngOnInit() {

    this.notificationType = "Both";
    this.notfFlag = true;
    this.showError = false;
    this.breadCrumbService.removeLastBreadCrumb();
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device Enrollment Program', routerLink: '/signupsetup/enrollmentoptions' });
    document.title = 'AT&T Business Console - Enrollment Options';
    // document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url]
    const previousRoute = sessionStorage.getItem('previousRoute');
    if (!sessionStorage.getItem('SignupBacktoCallingPage')) {
      sessionStorage.setItem('SignupBacktoCallingPage', previousRoute === '/productselection'
        || previousRoute === '/signupsetup' ? '/manageInventory' : previousRoute);
    }
    this.pivots = MOBILEPIVOTS.SIGNUPPAGE;
    const breadcrumbList = this.breadCrumbService.getBreadCrumbs();
    if (breadcrumbList.length > 1) {
      this.pivots[0].routerLink = breadcrumbList[breadcrumbList.length - 2].routerLink;
    }
    this.prodcode = sessionStorage.getItem('prodcode');
    this.failFromReviewFlag = sessionStorage.getItem('failFromReviewFlag');
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    this.pageDescription = '';

    this.termsCondproductURl = JSON.parse(sessionStorage.getItem('manage-product'));
    this.emmProductCode = this.termsCondproductURl.emmProductCode;
    if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP' || this.emmProductCode === 'DMPAABM') {
      this.prodFlag = true;
    } else {
      this.prodFlag = false;
    }


    this.router.navigate(['/productselection/enrollmentoptions']);
    // if(this.emmProductCode === 'DMPSKME') {
    //   this.accountsData.content = this.activatedRoute.snapshot.data.pageData.signupsetupenrollmentoptions;
    // } else {
    //   this.accountsData.content = this.activatedRoute.snapshot.data.pageData.productselectionenrollmentoptions;
    // }
    this.accountsData.content = this.activatedRoute.snapshot.data.pageData.productselectionenrollmentoptions;
    
    this.staticTcUrl = this.accountsData.content.termsAndConditionsURL ? this.accountsData.content.termsAndConditionsURL : "";

    //revert the <prodID> in tooltip in case of go back to service selection page
    if (this.accountsData.content.existingDevicesTooltip.indexOf("Apple Organization ID") == -1 ||
      this.accountsData.content.existingDevicesTooltip.indexOf("Google ID") == -1 ||
      this.accountsData.content.existingDevicesTooltip.indexOf("Knox Mobile Enrollment ID") == -1) {
      this.accountsData.content.existingDevicesTooltip = this.existingDevicesTooltipCommon;
    }

    this.accountsData.content.existingDevicesTooltip =
      this.accountsData.content.existingDevicesTooltip.replace('Apple Organization ID', '<prodID>');

    this.accountsData.content.existingDevicesTooltip =
      this.accountsData.content.existingDevicesTooltip.replace('Google ID', '<prodID>');

    this.accountsData.content.existingDevicesTooltip =
      this.accountsData.content.existingDevicesTooltip.replace('Knox Mobile Enrollment ID', '<prodID>');
    if (this.emmProductCode === 'DMPAABM' || this.failFromReviewFlag === 'true') {
      this.kme = false;
      this.ztp = false;
      this.abm = true;
      this.accountsData.content.existingDevicesTooltip =
        this.accountsData.content.existingDevicesTooltip.replace('<prodID>', 'Apple Organization ID');
      this.termscondUrl = TERMSCONDITIONS.URL.commonUrl;
    } else if (this.emmProductCode === 'DMPGZTP') {
      this.kme = false;
      this.ztp = true;
      this.abm = false;
      this.accountsData.content.existingDevicesTooltip =
        this.accountsData.content.existingDevicesTooltip.replace('<prodID>', 'Google ID');
      this.termscondUrl = TERMSCONDITIONS.URL.commonUrl;
    } else {
      this.kme = true;
      this.ztp = false;
      this.abm = false;
      this.accountsData.content.existingDevicesTooltip =
        this.accountsData.content.existingDevicesTooltip.replace('<prodID>', 'Knox Mobile Enrollment ID');
      this.termscondUrl = TERMSCONDITIONS.URL.commonUrl;
    }

    this.accountsData.content.note = this.accountsData.content.noteTmp.replace('<prodCode>', this.prodcode);
    this.readySignupSetupFans = [];
    this.readySignupSetupFans = JSON.parse(sessionStorage.getItem('signupFanList'));
    // this.isFansZero = (!this.readySignupSetupFans || (this.readySignupSetupFans && this.readySignupSetupFans.length === 0)) ? true : false;

    this.signupDataBack = JSON.parse(sessionStorage.getItem('signupFanList'));
    this.allFansData = JSON.parse(sessionStorage.getItem('fansForSignup'));
    this.signupData = this.signupSetupService.getSignupModel();
    this.backFromReview = JSON.parse(sessionStorage.getItem('backFromReview'));
    if (this.backFromReview) {
      this.signupData = true;
    }

    if (this.signupData || this.failFromReviewFlag === 'true') {
      /* Back from Review */
      this.signupSetupInputData = this.signupData.inputModel;
      this.signupSetupOutputData = this.signupData.outputModel;
      this.signupSetup = this.signupData.signupSetup;
      //this.selectedFanList = this.selectedFanLength();
      this.notificationType = this.signupDataBack.notificationType;
      this.checkedFanList = this.signupDataBack.selectedEnrollFans;
      this.enrollDates = this.signupDataBack.enrollArray;

      this.getFANList();
      //this.pageloaderService.setPageLoaderStatus(true);
    } else {

      //this.backFromReview = false;
      this.getFANList();

    }

    this.helpArticles = [{
      id: 1, isActive: true, category: 'Help', description: '', ariaLabel: {
        'expand': 'Show help',
        'collapse': 'Hide help'
      }
    }];
    const pageName = 'signupAccountsPage';
    if (!this.prodFlag) {
      this.signupSetupService.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument + pageName).
        subscribe(resp => {
          this.article = resp.supportArticles;
          this.supportArticle = true;
        }, () => {
          // this.handleError(err);
        });
    }
    this.signupSetupService.createPageLoadProperties('ACCOUNTS', 'Accounts');
    this.isABMFE = sessionStorage.getItem("ABMFE") ? JSON.parse(sessionStorage.getItem("ABMFE")) : false;
    let isABMFEClicked = sessionStorage.getItem("feFlag");
    if (isABMFEClicked == 'true' && this.isABMFE && this.prodcode == 'Apple Business Manager') {
      this.accountsData.content.existingDevicesTooltip = this.existingDevicesTooltipForABMFE;
    }
    this.productSelected = sessionStorage.getItem('product-selected');
    this.profileAndPermsInfo = JSON.parse(sessionStorage.getItem('profileAndPermsInfo'));
    this.fans = this.profileAndPermsInfo.profile.agreement.fans;
     this.fanNames = this.fans.map(fan => fan.fanName);
    // else{
    //   this.accountsData.content.existingDevicesTooltip = this.activatedRoute.snapshot.data.pageData.signupsetupenrollmentoptions.existingDevicesTooltip;
    // }
    this.IFDMock = this.accountsData.content.IFDMock; //false;
  }

  /*check mobile view for support article accordion*/
  mobileView() {
    this.helpArticles = [{ id: 1, isActive: !this.isMobile, category: 'Help', content: '' }];
  }


  ngAfterViewInit() {
    if (this.notificationType) {
      if (this.notificationType == "Both") {
        this.emailNotification.nativeElement.checked = true;
        this.textMessageNotification.nativeElement.checked = true;
        this.notfFlag = true;
      }
      else if (this.notificationType == "Email") {
        this.emailNotification.nativeElement.checked = true;
        this.textMessageNotification.nativeElement.checked = false;
        this.notfFlag = true;
      }
      else if (this.notificationType == "TextMessage") {
        this.emailNotification.nativeElement.checked = false;
        this.textMessageNotification.nativeElement.checked = true;
        this.notfFlag = true;
      }
      else {
        this.emailNotification.nativeElement.checked = false;
        this.textMessageNotification.nativeElement.checked = false;
        this.notfFlag = false;
      }
    }

  }


  /* Getting all fan list*/
  getFANList() {
    //console.log('Accounts Summary API request time => ' + new Date().getTime());
    this.signupSetupService.getFANList(this.companyId).
      subscribe(respobj => {
        //console.log('Accounts Summary API response time => ' + new Date().getTime());
        this.signupSetupInputData = new SignupSetupInputModel(respobj.companyId);
        this.signupSetupOutputData = new SignupSetupOutputModel(respobj.companyId);
        this.selectedFanList = this.selectedFanLength();
        this.signupSetupInputData.FANList = respobj;
        sessionStorage.setItem('fansForSignup', JSON.stringify(respobj.awaitingSignupFanList));
        this.signupSetupOutputData.emmProductCode = respobj.emmProductCode;
        sessionStorage.setItem('fansSignedUp', JSON.stringify(respobj.revisedFanList));

        this.buildTabView();

        this.pageloaderService.setPageLoaderStatus(true);
      }, () => this.handleError('fans'));
  }

  /* Review Based on the data ui have Tab or not*/
  buildTabView() {
    let tab = this.router['currentUrlTree'].queryParams.tab === undefined ? '' :
      this.router['currentUrlTree'].queryParams.tab;
    this.querytab = tab;
    this.signupSetupInputData.FANList.awaitingSignupFanList = this.signupSetupInputData.FANList.
      awaitingSignupFanList.filter((f) => { return f.addpEligibleStatus === true || f.addpEligibleStatus === undefined; });
    this.eligibleFanCount = this.signupSetupInputData.FANList.awaitingSignupFanList.filter(item => item.addpEligibleStatus).length;

    let count = 0;
    let accountsDataConfig = this.accountsData.config;
    if (tab === 'awaitingSignupFanList' && sessionStorage.getItem('previousRoute') === '/manageInventory' ||
      (sessionStorage.getItem('previousRoute') === '/productselection' &&
        ((this.termsCondproductURl.emmProductCode === 'DMPGZTP' || this.termsCondproductURl.emmProductCode === 'DMPSKME' ||
          this.termsCondproductURl.emmProductCode === 'DMPAABM')))) {
      //(<any>Object).values(accountsDataConfig).filter((f) => {
      //if (f.name === 'Add accounts') {
      //awaitingSignupConfig = f;
      //}
      //});
      accountsDataConfig = {
        awaitingSignupFanList: accountsDataConfig.awaitingSignupFanList
      };
      tab = undefined;
    }
    let fanType = 'awaitingSignupFanList';
    if (this.signupSetupInputData.FANList[fanType].length && (fanType !== 'awaitingSignupFanList' ||
      (fanType === 'awaitingSignupFanList' && this.eligibleFanCount !== 0))) {
      let activeFansList = this.addActiveFans();
      this.signupSetupInputData.FANList[fanType] = activeFansList.concat(this.signupSetupInputData.FANList[fanType])
      this.initGrid(this.signupSetupInputData.FANList[fanType], this.accountsData.config[fanType].columnDefinitions,
        fanType !== 'awaitingSignupFanList' ? this.accountsData.config[fanType].rowDisable :
          this.eligibleFanCount !== this.signupSetupInputData.FANList.awaitingSignupFanList.length,
        this.accountsData.config[fanType].rowDisableCondition,
        this.accountsData.config[fanType].rowDisableConditionInverse);
      this.tabArray.push({
        id: this.accountsData.config[fanType].name, name: fanType,
        isActive: (tab === fanType || tab === '' && count === 0), htmlFlag: '', description: ''
      });
      count++;
    }
    if (this.tabArray.length > 1) {
      if (this.tabArray.filter(item => item.isActive).length === 0) {
        this.tabArray[0].isActive = true;
      }
    }
    if (this.signupSetupInputData.FANList[fanType].length == 0) {
      let activeFansList = this.addActiveFans();
      this.signupSetupInputData.FANList[fanType] = activeFansList.concat(this.signupSetupInputData.FANList[fanType])
      const fanIdArr = this.signupSetupInputData.FANList[fanType].map(o => o.fanId)
      this.signupSetupInputData.FANList[fanType] = this.signupSetupInputData.FANList[fanType].filter(({ fanId }, index) => !fanIdArr.includes(fanId, index + 1))

      this.initGrid(this.signupSetupInputData.FANList[fanType], this.accountsData.config[fanType].columnDefinitions,
        fanType !== 'awaitingSignupFanList' ? this.accountsData.config[fanType].rowDisable :
          this.eligibleFanCount !== this.signupSetupInputData.FANList.awaitingSignupFanList.length,
        this.accountsData.config[fanType].rowDisableCondition,
        this.accountsData.config[fanType].rowDisableConditionInverse);
      this.tabArray.push({
        id: this.accountsData.config[fanType].name, name: fanType,
        isActive: (tab === fanType || tab === '' && count === 0), htmlFlag: '', description: ''
      });
      count++;
    }

    this.signupSetup = this.tabArray.length === 1 && this.tabArray[0].name === 'awaitingSignupFanList';
    //this.setAccountsHelpMessage();

    if (this.signupSetup) {
      this.signupSetupInputData.FANList.awaitingSignupFanList.map(fan => {
        if (fan.addpEligibleStatus) {
          //fan.selected = true;
        }
        return fan;
      });
      this.onRowClick('');
    }
  }

  addActiveFans() {

    let emmProductCode = null;
    if (this.prodcode === "Apple Business Manager") {
      emmProductCode = "DMPAABM";
    } else if (this.prodcode === "Android Zero-touch") {
      emmProductCode = "DMPGZTP";
    } else if (this.prodcode === "Samsung Knox Mobile Enrollment (KME)") {
      emmProductCode = "DMPSKME";
    }

    let fanInfoList;
    if (sessionStorage.getItem("fanInfoList") !== "undefined") {
      fanInfoList = JSON.parse(sessionStorage.getItem("fanInfoList"));
      if (fanInfoList) {
        let inEligibleList = fanInfoList.filter(
          (item) =>
            item.emmProductCode === emmProductCode && (item.accountStatus === "ACTIVE" || item.accountStatus === "SIGNUP_INPROGRESS")
        );

        if (inEligibleList && inEligibleList.length > 0) {
          let tempData = [];
          inEligibleList.map(function (item) {
            tempData = fanInfoList.filter((x) => x.fan !== item.fan);
            fanInfoList = tempData;
          });
        }
      }
    }
    let listFans = [];
    let obj = {}
    if (fanInfoList) {
      fanInfoList.map(function (item, index) {
        obj = {}
        obj["fanId"] = item.fan;
        obj["addpEligibleStatus"] = true;
        listFans.push(obj);

      })
    }

    const fanIdArr = listFans.map(o => o.fanId)
    listFans = listFans.filter(({ fanId }, index) => !fanIdArr.includes(fanId, index + 1))

    return listFans;
  }

  initGrid(respobj, colDef: Array<ColumnDefinitionsModel>, disableRow: boolean, disableRowCondition,
    disableRowConditionInverse) {
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = true;
    options.disableSelectAll = true;
    //options.emptyMessage = 'No records';
    //options.enableBackLink = true;
    //options.ariaLabel = 'Select all foundation accounts.';
    //options.backLinkText = 'View all accounts';
    //options.emptyMessage = 'We didn\'t find any foundation accounts that match your search. Did you enter a full account number? ' +
    //'Check the number and try again.';
    if (disableRow) {
      options.disableRow = true;
      options.disableRowCondition = disableRowCondition;
      options.disableRowConditionInverse = disableRowConditionInverse;
    }

    // const preSelectedFan = sessionStorage.getItem('selectedFAN');
    // if (preselectTab && preSelectedFan) {
    //   const selectedFan: FanModel = respobj.filter(fan => fan.fanId === preSelectedFan)[0];
    //   if (selectedFan && selectedFan.accountStatus && selectedFan.accountStatus.toUpperCase() === 'ACTIVE') {
    //     //selectedFan.selected = true;
    //     this.accountsData.content.selectedFans = this.accountsData.content.selectedFanTmp.replace('<selectedFanCount>', 1);
    //     this.accountsData.content.selectedFans = this.accountsData.content.selectedFans.replace('<account/accounts>',
    //       'account');
    //     //this.selected['revisedFanList'] = true;
    //     // this.signupSetupInputData.FANList.revisedFanList.forEach(item1 => {
    //     //   if (item1.fanId === selectedFan.fanId) {
    //     //     item1.selected = true;
    //     //   }
    //     // });
    //     this.signupSetupOutputData.FANList['revisedFanList'] =
    //       this.signupSetupInputData.FANList['revisedFanList'].filter(item => item.selected === true);
    //     this.selectedFanList = 1;
    //     this.gridOptions.forEach((data) => {
    //       data.disableGrid = true;
    //     });

    //   }
    // }

    const mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));

    // if (callback === 'awaitingSignupFanList' || callback === 'revisedFanList') {
    //   options.callbacks = { fanEligiblityStatus: this.fanEligiblityStatus };
    // }
    options.callbacks = { fanEligiblityStatus: this.fanEligiblityStatus };

    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: respobj.length
    };

    options.Paginations = pagination;

    //make change to filter selectedfanlist from respobj but also compare with signedupdata array for enroll
    const totalFanList = JSON.parse(sessionStorage.getItem('signedupData'));
    if (totalFanList) {
      let matchFound: boolean;
      respobj.forEach(element => {
        matchFound = false;
        totalFanList.forEach(element1 => {
          if (element.fanId === element1.fanId) {
            // element.selected = true;
            if (element1.enroll) {
              element.enroll = true;
            } else {
              element.enroll = false;
            }
            matchFound = true;
          } else {
            if (!matchFound) {
              element.selected = false;
            }
          }
          //console.log(element);
          //console.log(element1);

        });
      });
    }


    options.gridData = respobj;
    options.columnDefinitions = colDef;

    //show checkbox true if signupData has done(come back from review page)
    let signupFanList = sessionStorage.getItem('signupFanList') ? JSON.parse(sessionStorage.getItem('signupFanList')) : [];
    let signedupData = sessionStorage.getItem('signedupData') ? JSON.parse(sessionStorage.getItem('signedupData')) : [];
    options.gridData.forEach((gridFan) => {
      let checkedMatch = (signupFanList && signupFanList.selectedEnrollFans) ? signupFanList.selectedEnrollFans.find((item) => item.fanId === gridFan.fanId) : null;
      let isEnrolled = (signedupData) ? signedupData.find((item) => item.fanId === gridFan.fanId) : null;
      this.matchingFan = this.fans.find((fan) => fan.fanId === gridFan.fanId);
      if (this.matchingFan) {
        this.companyName = this.matchingFan.fanName;
        gridFan['fanName'] = this.companyName;
        gridFan.selected = checkedMatch ? checkedMatch.selected : gridFan.selected;
        gridFan.enroll = isEnrolled ? isEnrolled.enroll : gridFan.enroll;
        // options.gridData.push(this.companyName);
        // this.fanNames = this.fans.map(fan => fan.fanName);
      }
    });
    //check apple dep for fan
    console.log("options.gridData==>", options.gridData);
    let mapApleDep = sessionStorage.getItem("mapAppleDep") ? JSON.parse(sessionStorage.getItem("mapAppleDep")) : [];
    let appleDepRecord = [];
    if (mapApleDep.length > 0) {
      let map1 = new Map(mapApleDep);
      console.log("map1.entries===>", map1.entries())
      options.gridData.forEach((elm) => {
        if (map1.has(elm.fanId)) {
          appleDepRecord.push(elm);
        }
      })
      console.log(appleDepRecord);
    }

    options.gridData = options.gridData.map(data => {
      if (data.enroll === undefined) {
        data.enroll = false;
      }

      if (this.emmProductCode === 'DMPAABM') {
        appleDepRecord.forEach((el) => {
          if (el.fanId == data.fanId) {
            data.isAppleDEP = true;
          }
        });
      }


      return data;
    });
    //options.searchPlaceHolder = 'Enter full foundation account number';
    //options.searchType = 'number';
    this.gridOptions.push(options);
    console.log(this.gridOptions);
  }

  fanEligiblityStatus(element, row, field, currentElem, type) {
    if (type === 'template') {
      return `<div class="${row.addpEligibleStatus ? '' : ''}">${row.fanId}</div>`;
    }
  }

  /* Fan selection watched here from Grid*/
  onRowClick(action) {

    if (action !== "") {
      if (action.data.selected === false && action.data.enroll === true) {
        action.data.enroll = false;
        let array: any[] = JSON.parse(sessionStorage.getItem('enrollArray'));
        if (array !== null) {
          this.enrollArray = array.filter(item => item !== action.data.fanId);
          //console.log(this.enrollArray);
          sessionStorage.setItem('enrollArray', JSON.stringify(this.enrollArray));
        }
      } else if (action.data.selected === false && action.data.enroll === false) {

        action.data.enroll = false;
        let array: any[] = JSON.parse(sessionStorage.getItem('enrollArray'));
        if (array !== null) {
          this.enrollArray = array.filter(item => item !== action.data.fanId);
          //console.log(this.enrollArray);
          sessionStorage.setItem('enrollArray', JSON.stringify(this.enrollArray));
        }
      }
    }
    const fanType = 'awaitingSignupFanList';
    //this.enrollEnable = true;

    this.signupSetupOutputData.FANList[fanType] = this.signupSetupInputData.FANList[fanType].filter(item => item.selected === true);

    sessionStorage.setItem('selectedSignupFanList', JSON.stringify(this.signupSetupOutputData.FANList.awaitingSignupFanList));

    this.selectedFanList = this.selectedFanLength();
    this.checkNDisableFANList();

  }

  existingDevices(row) {

    const fromBackFlag = JSON.parse(sessionStorage.getItem('step1done'));
    let updateSelectedSignupFanList = JSON.parse(sessionStorage.getItem('selectedSignupFanList'));
    if (fromBackFlag || this.failFromReviewFlag) {
      this.enrollArray = JSON.parse(sessionStorage.getItem('enrollArray'));
      if (this.enrollArray !== null) {
        if (this.enrollArray.includes(row.fanId) !== true) {
          if (row.enroll !== row.selected) {
            this.enrollArray.push(row.fanId);
          }
        } else {
          //this.enrollArray.remove(row.fanId);
          const index = this.enrollArray.indexOf(row.fanId);
          if (index > -1) {
            this.enrollArray.splice(index, 1);
          }
          console.log(this.enrollArray);
        }
      } else {
        this.enrollArray = [];
        row.enroll = true;
        this.enrollArray.push(row.fanId);
      }
      sessionStorage.setItem('enrollArray', JSON.stringify(this.enrollArray));
      updateSelectedSignupFanList.forEach(element => {
        if (element.fanId === row.fanId) {
          element.enroll = row.selected;
        }
      });
      sessionStorage.setItem('selectedSignupFanList', JSON.stringify(updateSelectedSignupFanList));
      sessionStorage.removeItem('step1done');
    } else {
      //this.enrollArray.push(row.fanId);
      if (this.enrollArray.includes(row.fanId) === false) {
        this.enrollArray.push(row.fanId);
      }
      sessionStorage.setItem('enrollArray', JSON.stringify(this.enrollArray));
      sessionStorage.removeItem('step1done');
    }
    //console.log(this.enrollArray);

  }

  enableContinue() {
    if (this.selectedFanList === 0) {
      if (this.notfFlag) {
        this.enableCont = false;
        this.signupSetupService.updateContinueBtnStatus(false);
      } else {
        this.enableCont = false;
        this.signupSetupService.updateContinueBtnStatus(false);
      }
    } else if (this.selectedFanList > 0) {
      if (this.notfFlag) {
        this.enableCont = true;
        this.signupSetupService.updateContinueBtnStatus(true);
      } else {
        this.enableCont = false;
        this.signupSetupService.updateContinueBtnStatus(false);
      }
    }
  }

  /* One Fan List is selected other list disabled*/
  checkNDisableFANList() {
    this.gridOptions.forEach((data, index) => {
      data.disableGrid = !!this.selectedFanList && !this.signupSetupOutputData.FANList[this.tabArray[index].name].length;
    });

    // let emmProductCode =null;
    // if (this.prodcode === "Apple Business Manager") {
    //   emmProductCode = "DMPAABM";
    // } else if (this.prodcode === "Android Zero-touch") {
    //   emmProductCode = "DMPGZTP";
    // } else if (this.prodcode === "Samsung Knox Mobile Enrollment (KME)") {
    //   emmProductCode = "DMPSKME";
    // }

    // let fanInfoList = JSON.parse(sessionStorage.getItem("fanInfoList"));
    // if (fanInfoList) {
    //   let inEligibleArr1 = fanInfoList.filter(
    //     (x) =>
    //       x.emmProductCode === emmProductCode && x.accountStatus === "ACTIVE"
    //   );

    //   let inEligibleArr2 = fanInfoList.filter(function(item){
    //     if(item.emmProductCode === "DMPGZTP"&& item.accountStatus === "ACTIVE" ){
    //       if(emmProductCode === "DMPSKME" ){
    //         return item;
    //       }
    //     }
    //   })

    //   let inEligibleArr3 = fanInfoList.filter(function(item){
    //     if(item.emmProductCode === "DMPSKME"&& item.accountStatus === "ACTIVE" ){
    //       if(emmProductCode === "DMPGZTP" ){
    //         return item;
    //       }
    //     }
    //   })


    //   let inEligibleList = inEligibleArr1.concat(inEligibleArr2).concat(inEligibleArr3);



    //   let gridData = this.gridOptions[0].gridData;
    //   if (inEligibleList && inEligibleList.length > 0) {
    //     let tempData = [];
    //     inEligibleList.map(function (item) {
    //       tempData = gridData.filter((x) => x.fanId !== item.fan);
    //       gridData = tempData;

    //     });
    //     this.gridOptions[0].gridData = tempData;
    //   }
    // }

    const fanIdArr = this.gridOptions[0].gridData.map(o => o.fanId)
    this.gridOptions[0].gridData = this.gridOptions[0].gridData.filter(({ fanId }, index) => !fanIdArr.includes(fanId, index + 1))

    this.isFansZero = (this.gridOptions[0].gridData.length === 0) ? true : false;

    this.enableContinue();
  }

  /* Show Selected FAN's in html*/
  selectedFanLength() {
    const selFans = [];
    for (const fanType in this.accountsData.config) {
      if (this.signupSetupOutputData.FANList[fanType].length !== 0) {
        this.selected[fanType] = true;
      } else {
        this.selected[fanType] = false;
      }
      if (this.signupSetupOutputData.FANList[fanType].length) {
        this.signupSetupOutputData.FANList[fanType].forEach(cols => selFans.push(cols.fanId));
      }
    }
    this.accountsData.content.selectedFans = this.accountsData.content.selectedFanTmp.replace('<selectedFanCount>', selFans.length);
    this.accountsData.content.selectedFans = this.accountsData.content.selectedFans.replace('<account/accounts>',
      selFans.length === 0 ? 'accounts' : selFans.length > 1 ? 'accounts' : 'account');
    this.selectedFansCount[this.activeTab] = this.accountsData.content.selectedFans;
    return selFans.length;
  }

  setNotification(event) {
    if (this.emailNotification.nativeElement.checked == true && this.textMessageNotification.nativeElement.checked == true) {
      this.notificationType = "Both";
      this.notfFlag = true;
    }
    else if (this.emailNotification.nativeElement.checked == true && this.textMessageNotification.nativeElement.checked == false) {
      this.notificationType = "Email";
      this.notfFlag = true;
    }
    else if (this.emailNotification.nativeElement.checked == false && this.textMessageNotification.nativeElement.checked == true) {
      this.notificationType = "TextMessage";
      this.notfFlag = true;
    }
    else {
      this.notificationType = "";
      this.notfFlag = false;
    }

    this.enableContinue();
  }

  handleError(type) {
    if (type === 'summary') {
      this.initModal = true;
      this.modalClass = 'pop-up';
      this.modalMsg = 'SystemFailure';
      this.pageloaderService.setPageLoaderStatus(true);
    } else {
      this.showError = true;
      this.pageloaderService.setPageLoaderStatus(true);
      this.errorMessage = this.accountsData.content.errorMessages[type];
      if (document.getElementById('alertMessage')) {
        document.getElementById('alertMessage').classList.remove('msgShown');
      }
    }
  }

  // toggleTooltip(event) {
  //   if (event.type !== 'click') {
  //     if (event.keyCode !== KEY_CONFIG.enter) {
  //       return;
  //     }
  //   }
  //   let targetElement = event.target;
  //   const elems = document.querySelectorAll('.tooltipActive');
  //   let iselementActive = false;
  //   if (targetElement.classList.contains('tooltipActive')) {
  //     iselementActive = true;
  //   }
  //   [].forEach.call(elems, function (ele) {
  //     ele.classList.remove('tooltipActive');
  //   });
  //   if (iselementActive) {
  //     targetElement.classList.remove('tooltipActive');
  //   } else {
  //     targetElement.classList.add('tooltipActive');
  //   }
  // }

  toggleTooltipEnter(event) {
    if (event.type !== 'mouseenter') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipLeave(event) {
    if (event.type !== 'mouseleave') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  backToProductSelection(event) {
    event.preventDefault();
    //const previousRoute = sessionStorage.getItem('previousRoute');
    this.router.navigate(['/productselection']);
  }

  backToInitialSetup(event) {
    event.preventDefault();
    this.signupSetupService.removeSignupModel();
    this.breadCrumbService.removeLastBreadCrumb();
    sessionStorage.removeItem('enrollmentSelectedDetails');
    sessionStorage.removeItem('savedSelectedDetails');
    //const currentUrl = this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink;
    if (this.prodcode === 'Apple Business Manager') {
      sessionStorage.setItem('selectedProd', 'applebusinessmanager');
    } else if (this.prodcode === 'Android Zero-touch') {
      sessionStorage.setItem('selectedProd', 'androidzerotouch');
    } else if (this.prodcode === 'Samsung Knox Mobile Enrollment (KME)') {
      sessionStorage.setItem('selectedProd', 'samsungknoxmobile');
    }
    const unclaim = sessionStorage.getItem('unclaimFlag') ? JSON.parse(sessionStorage.getItem('unclaimFlag')) : false;
    if (unclaim) {
      const previousUrl = sessionStorage.getItem('currentRoute');
      this.router.navigate([previousUrl]);
    } else {
      this.router.navigate(['/productselection/enrollmentoptions']);
    }
  }

  continueToNext() {
    // this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formSubmit',
    //   'BC_Device_SignupSetup_Continue_Submit', 'success', 'Success_Admit', 'Continue', 'Body', '/businessconsole/signupsetup/review');

    const checkFANSelected = this.signupSetupOutputData.FANList.awaitingSignupFanList.length;
    const selectedSignupFanList = JSON.parse(sessionStorage.getItem('selectedSignupFanList'));
    sessionStorage.removeItem('failFromReviewFlag');

    if (!checkFANSelected) {
      this.showError = true;
      this.errorMessage = this.accountsData.content[(this.haveTab ? 'tab' : 'noTab') +
        this.tabArray[this.activeTab].name].errorMessage;
    } else {
      this.showError = false;
      this.initialSignup = true;
      let data = {
        "prodcode": this.prodcode,
        "notificationType": this.notificationType,
        "enrollArray": this.enrollArray,
        "selectedEnrollFans": selectedSignupFanList
      }

      sessionStorage.setItem('step1done', 'true');
      sessionStorage.setItem('signupFanList', JSON.stringify(data));
      //this.router.navigate(['/signupsetup/review']);

      //google id validation
      if (this.prodcode === 'Android Zero-touch') {

        const manageProduct = JSON.parse(sessionStorage.getItem('manage-product'));
        const selectedAccID = manageProduct.selectedAccID;
        const selectedId = Number.parseInt(selectedAccID);
        const user = JSON.parse(sessionStorage.getItem('user'));
        const agreementID = user.user.agreement.id;

        if (Number.isInteger(selectedId)) {
          this.router.navigate(['/productselection/review']);
        } else {
          if(this.ztpIdres != null){
            // this.productSelectionService.zteIdValidation(this.ztpIdres, agreementID)
            // .subscribe(response => {
            //   this.pageloaderService.setPageLoaderStatus(true);
            //   if (response.status == 'failure' || response.errorCode == 'E0404') {
            //     this.pageLoaderService.setPageLoaderStatus(true);
            //     const previousRoute = sessionStorage.getItem('previousRoute');
            //     this.showGoogleCreationError = true;
            //     this.showErrors = true;
            //     this.errorMessage = response.error;
            //     this.router.navigate([previousRoute]);
            //   } else {
                // sessionStorage.removeItem('manage-product');
                let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                productDetails.emmProductCode = 'DMPGZTP';
                productDetails.selectedAccID = this.ztpIdres;
                productDetails.signupEmmStatus = 'initial';
                sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
                sessionStorage.removeItem('savedSelectedDetails');
                sessionStorage.removeItem('enrollmentSelectedDetails');

                this.router.navigate(['/productselection/review']);
              // }
            // });
          }else{
            // this.pageLoaderService.setPageLoaderStatus(false);
            // this.signupSetupService.createZtpAccount(selectedAccID, agreementID)
            // .subscribe(response => {
            //   if (response.status === 'success') {
            //     this.pageLoaderService.setPageLoaderStatus(true);
                // sessionStorage.removeItem('manage-product');
                
                sessionStorage.removeItem('savedSelectedDetails');
                sessionStorage.removeItem('enrollmentSelectedDetails');
                this.router.navigate(['/productselection/review']);
            //   } else {
            //     this.pageLoaderService.setPageLoaderStatus(true);
            //     // event.preventDefault();
            //     const previousRoute = sessionStorage.getItem('previousRoute');
            //     this.showGoogleCreationError = true;
            //     this.showErrors = true;
            //     this.errorMessage = response.error;
            //     //sessionStorage.setItem('showGoogleCreationError', 'true');
            //     // this.router.navigate([previousRoute]);
            //   }
            // });
          }
        }
      } else {
        // let ABMFE = sessionStorage.getItem("ABMFE") ? JSON.parse(sessionStorage.getItem("ABMFE")) : false;
        let isABMFEClicked_ = sessionStorage.getItem("feFlag");
        if (this.isABMFE === true && isABMFEClicked_ == 'true') {//get response from ROME IFD call for Apple FE request
          let d = new Date();
          let dd = ("0" + d.getDate()).slice(-2);
          let mm = ("0" + (d.getMonth() + 1)).slice(-2);
          let yy = String(d.getFullYear()).slice(-2);
          // let yy = d.getFullYear();
          let hh = ("0" + d.getHours()).slice(-2);
          let mms = ("0" + d.getMinutes()).slice(-2);
          let ss = ("0" + d.getSeconds()).slice(-2);
          let selectedFanList = sessionStorage.getItem("selectedSignupFanList") ? JSON.parse(sessionStorage.getItem("selectedSignupFanList")) : [];
          if (selectedFanList.length > 0) {
            let fanId = selectedFanList[0].fanId;

            let payload = {
              "requestId": "SAPMP-" + mm + dd + yy + hh + mms + ss,
              "sourceSystem": "SAPMP",
              "fanId": fanId
            }

            this.pageLoaderService.setPageLoaderStatus(false);
            if (this.IFDMock) {
              this.signupSetupService.getIFDMockDetails().subscribe((resp) => {
                console.log("mock response==>", resp);
                this.pageLoaderService.setPageLoaderStatus(true);
                if (resp.InquireFanDetailsResponse.operationStatus == 'SUCCESS') {
                  this.isROMEFailed = false;
                  console.log("ROME IFD Response: " + resp);
                  if (this.validateIFDCustomerDetails(resp?.InquireFanDetailsResponse?.FanDetails?.CustomerContactDetails)) {
                    if (this.validateIFDAccountDetails(resp?.InquireFanDetailsResponse?.FanDetails?.AccountDetails)) {
                      let accountDetails = resp?.InquireFanDetailsResponse?.FanDetails?.AccountDetails;
                      let isOrgTypeIsEducation = false;
                      if (accountDetails?.orgType && accountDetails?.orgType != '') {
                        let naicsCode = accountDetails?.orgType;
                        if (naicsCode.slice(0, 2) == 61) {
                          isOrgTypeIsEducation = true;
                        } else {
                          isOrgTypeIsEducation = false;
                        }
                      }
                      if (isOrgTypeIsEducation) {
                        this.showIFDError(this.IFDGenericErrorMessage);
                      } else {
                        sessionStorage.setItem("romeResponse", JSON.stringify(resp));
                        this.isROMEFailed = false;
                        // this.router.navigate(['/signupsetup/review']);
                        this.router.navigate(['/productselection/review']);
                      }
                    } else {
                      this.showIFDError(this.IFDGenericErrorMessage);
                    }
                  } else {
                    this.showIFDError(this.IFDGenericErrorMessage);
                  }
                } else {
                  // this.showIFDError(resp.InquireFanDetailsResponse.errorCode + " : " + resp.InquireFanDetailsResponse.errorMessage);
                  this.showIFDError(this.IFDGenericErrorMessage);
                }
              }, (error) => {
                this.pageLoaderService.setPageLoaderStatus(true);
                this.showIFDError(this.IFDCommonErrorMessage);
                // console.error(error);
              })
            } else {
              this.signupSetupService.getInquireFanDetails(payload).
                subscribe(resp => {
                  this.pageLoaderService.setPageLoaderStatus(true);
                  if (resp.InquireFanDetailsResponse.operationStatus == 'SUCCESS') {
                    this.isROMEFailed = false;
                    console.log("ROME IFD Response: " + resp);
                    if (this.validateIFDCustomerDetails(resp?.InquireFanDetailsResponse?.FanDetails?.CustomerContactDetails)) {
                      if (this.validateIFDAccountDetails(resp?.InquireFanDetailsResponse?.FanDetails?.AccountDetails)) {
                        let accountDetails = resp?.InquireFanDetailsResponse?.FanDetails?.AccountDetails;
                        let isOrgTypeIsEducation = false;
                        if (accountDetails?.orgType && accountDetails?.orgType != '') {
                          let naicsCode = accountDetails?.orgType;
                          if (naicsCode.slice(0, 2) == 61) {
                            isOrgTypeIsEducation = true;
                          } else {
                            isOrgTypeIsEducation = false;
                          }
                        }
                        if (isOrgTypeIsEducation) {
                          this.showIFDError(this.IFDGenericErrorMessage);
                        } else {
                          sessionStorage.setItem("romeResponse", JSON.stringify(resp));
                          this.isROMEFailed = false;
                          // this.router.navigate(['/signupsetup/review']);
                          this.router.navigate(['/productselection/review']);
                        }
                      } else {
                        this.showIFDError(this.IFDGenericErrorMessage);
                      }
                    } else {
                      this.showIFDError(this.IFDGenericErrorMessage);
                    }
                  } else {
                    this.showIFDError(this.IFDCommonErrorMessage);
                  }
                }, (error) => {
                  this.pageLoaderService.setPageLoaderStatus(true);
                  this.showIFDError(this.IFDCommonErrorMessage);
                  // console.error(error);
                });
            }

          }
        } else {
          this.router.navigate(['/productselection/review']);
        }

      }

    }
  }

  enterOrgIdPage() {
    // this.pageLoaderService.setPageLoaderStatus(false);
    // this.router.navigate(['/signupsetup/enrollmentoptions']);
    // this.enterOrgIdPage = true;
    let prevPage = sessionStorage.getItem('prevPage');
    let selectedProgram = sessionStorage.getItem('selectedProgram');
    this.router.navigate(['/productselection'],{
      state: { selectedProgram: selectedProgram, prevPage: prevPage }
    });
    sessionStorage.setItem('backFromFanSelectionPage', 'true');

  }

  showIFDError(errorMsg: string) {
    window.scrollTo(0, 0);
    this.isROMEFailed = true;
    this.IFDErrorMessage = errorMsg;
  }

  dismissInfo() {
    this.isROMEFailed = false;
  }

  arrayCompare(arr1, arr2) {
    return arr1.every(elm => elm.required && arr2.includes(elm.attrName));
  }

  checkFieldsSize(arr1, obj) {
    return arr1.every(elm => obj[elm.attrName] != '' && obj[elm.attrName].length <= elm.size);
  }

  validateIFDCustomerDetails(customerDetails: any) {
    if (customerDetails && customerDetails.length > 0) {
      //  return customerDetails.every((customer: any) => {
      //     let custKeys = Object.keys(customer);
      //     if(!this.arrayCompare(this.abmfeRequiredFields["customerContactDetails"], custKeys)){
      //       return false
      //     }else{
      //       if(!this.checkFieldsSize(this.abmfeRequiredFields["customerContactDetails"], customer)){
      //         return false; 
      //       }
      //     }
      //   })
      return customerDetails.every(customer => this.arrayCompare(this.abmfeRequiredFields["customerContactDetails"], Object.keys(customer)) && this.checkFieldsSize(this.abmfeRequiredFields["customerContactDetails"], customer));
      // return true;
    } else {
      return false;
    }
  }

  validateIFDAccountDetails(accountDetails: any) {
    let accKeys = Object.keys(accountDetails);
    if (!this.arrayCompare(this.abmfeRequiredFields["accountDetails"], accKeys)) {
      return false;
    } else {
      if (!this.checkFieldsSize(this.abmfeRequiredFields["accountDetails"], accountDetails)) {
        return false;
      } else {
        return true;
      }

    }
  }
}
